import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/login',
            name: 'login',
            component: () =>
                import ('./views/Login'),
        },
        //超管用
        {
            path: '/admin',
            component: () =>
                import ('./views/admin/Index'),
            redirect: 'admin/progress',
            children: [{
                    path: '/admin/video',
                    name: 'admin/video',
                    component: () =>
                        import ('./views/admin/Video'),
                },
                {
                    path: '/admin/progress',
                    name: 'admin/progress',
                    component: () =>
                        import ('./views/admin/Progress'),
                },
                {
                    path: '/admin/aistr',
                    name: 'admin/aistr',
                    component: () =>
                        import ('./views/admin/AiStr'),
                },
                {
                    path: '/admin/user',
                    name: 'admin/user',
                    component: () =>
                        import ('./views/admin/User'),
                },
                {
                    path: '/admin/product',
                    name: 'admin/product',
                    component: () =>
                        import ('./views/admin/Product'),
                },
                {
                    path: '/admin/task',
                    name: 'admin/task',
                    component: () =>
                        import ('./views/admin/Task'),
                },
                {
                    path: '/admin/album',
                    name: 'admin/album',
                    component: () =>
                        import ('./views/admin/Album'),
                },
                {
                    path: '/admin/audio',
                    name: 'admin/audio',
                    component: () =>
                        import ('./views/admin/Audio'),
                },
                {
                    path: '/admin/music',
                    name: 'admin/music',
                    component: () =>
                        import ('./views/admin/Music'),
                }

            ]
        },
        //客户站
        {
            path: '/',
            component: () =>
                import ('./views/Index'),
            redirect: 'home',
            children: [
                //首页
                {
                    path: '/home',
                    name: 'home',
                    component: () =>
                        import ('./views/Home'),
                },
                //视频创作
                {
                    path: '/quick',
                    name: 'quick',
                    component: () =>
                        import ('./views/Quick'),

                },
                //产品
                {
                    path: '/product',
                    name: 'product',
                    component: () =>
                        import ('./views/Product'),
                    redirect: 'product/list',
                    children: [{
                        path: '/product/list',
                        name: 'product/list',
                        component: () =>
                            import ('./components/product/list')
                    }, {
                        path: '/product/keyword',
                        name: 'product/keyword',
                        component: () =>
                            import ('./components/product/keyword'),
                    }]
                },
                //素材
                {
                    path: '/material',
                    name: 'material',
                    component: () =>
                        import ('./views/Material'),
                    redirect: 'material/photo',
                    children: [{
                        path: '/material/photo',
                        name: 'material/photo',
                        component: () =>
                            import ('./components/material/photo')
                    }, {
                        path: '/material/particular',
                        name: 'material/particular',
                        component: () =>
                            import ('./components/material/photoParticular')
                    }, {
                        path: '/material/subtitle',
                        name: 'material/subtitle',
                        component: () =>
                            import ('./components/material/subtitle')
                    }, {
                        path: '/material/bgmusic',
                        name: 'material/bgmusic',
                        component: () =>
                            import ('./components/material/bgmusic')
                    }, {
                        path: '/material/dubbing',
                        name: 'material/dubbing',
                        component: () =>
                            import ('./components/material/dubbing')
                    }],
                },
                //任务
                {
                    path: '/task',
                    name: 'task',
                    component: () =>
                        import ('./views/Task'),
                    redirect: 'task/list',
                    children: [{
                        path: '/task/list',
                        name: 'task/list',
                        component: () =>
                            import ('./components/task/list'),
                    }, {
                        path: '/task/detail',
                        name: 'task/detail',
                        component: () =>
                            import ('./components/task/detail'),
                    }]
                },
                //视频
                {
                    path: '/video',
                    name: 'video',
                    component: () =>
                        import ('./views/Video'),
                    redirect: 'video/list',
                    children: [{
                        path: '/video/list',
                        name: 'video/list',
                        component: () =>
                            import ('./components/video/list')
                    }]
                },

            ]
        },
        {
            path: '/userinfo',
            name: 'userinfo',
            component: () =>
                import ('./views/Userinfo'),
        },
        // 快剪
        {
            path: '/quickcut',
            name: 'QuickCut',
            component: () =>
                import ('./views/QuickCut.vue'),
            redirect: 'clip/quickcut',
            children: [{
                path: '/clip/quickcut',
                name: 'clip/quickcut',
                component: () =>
                    import ('./components/clip/index.vue')
            }]
        },
        // 快剪列表页面
        {
            path: '/quicklist',
            name: 'QuickList',
            component: () =>
                import ('./views/quicklist.vue'),
            redirect: 'clip/list',
            children: [{
                path: '/clip/list',
                name: 'clip/list',
                component: () =>
                    import ('./components/clip/list.vue')
            }]
        },
        //下载
        {
            path: '/down',
            name: 'down',
            component: () =>
                import ('./views/Down'),
        }
    ]
})